import { Outlet } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useState, useEffect } from "react";
import Header from "./Header";
import AutoLogoutModal from "./AutoLogoutModal";
import * as common from "../../common/common";
import CssClass from "../../App.css";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const Layout = () => {
  // const [isNavOpen, setIsNavOpen] = useState(true);
  const [cookies, setCookie, removeCookies] = useCookies([]);

  const [checkLogoutShow, setCheckLogoutShow] = useState(false);

  // const autoLogoutModalHide = () => {
  //   setCheckLogoutShow(!checkLogoutShow);
  // };

  // function setHeader(star) {
  //   setIsNavOpen(!star);
  // }

  function confirmLogout() {
    removeCookies("USER_NAME");
    removeCookies("USER_ID");
    removeCookies("EMAIL");
    removeCookies("ORG_NAME")
    window.location = common.c_getWebLoginUrl() + "Login";
  }

  // function confirmAutoLogout() {
  //   setCheckLogoutShow(!checkLogoutShow);
  //   confirmLogout();
  // }

  // function checkBeforeLogout() {
  //   setCheckLogoutShow(!checkLogoutShow);
  //   var autoLogoutConfirm = window.setTimeout(() => confirmLogout(), 30 * 1000);
  //   document.onmousedown = () => {
  //     resetLogoutTimeout(autoLogoutConfirm);
  //   };
  //   document.onkeydown = () => {
  //     resetLogoutTimeout(autoLogoutConfirm);
  //   };
  //   return autoLogoutTimeout;
  // }

  // function resetLogoutTimeout(autoLogout) {
  //   window.clearTimeout(autoLogout);
  //   autoLogout = window.setTimeout(
  //     () => checkBeforeLogout(),
  //     cookies.AUTO_LOGOUT_DURATION * 60 * 1000
  //   );
  //   document.onmousedown = () => {
  //     setCheckLogoutShow(false);
  //     resetLogoutTimeout(autoLogout);
  //   };
  //   document.onkeydown = () => {
  //     setCheckLogoutShow(false);
  //     resetLogoutTimeout(autoLogout);
  //   };
  // }

  // useEffect(() => {
  //   if (Object.keys(cookies).length !== 0 && cookies.EMAIL.trim() !== "") {
  //     var autoLogout = window.setTimeout(
  //       () => checkBeforeLogout(),
  //       cookies.AUTO_LOGOUT_DURATION * 60 * 1000
  //     );
  //     document.onmousedown = () => {
  //       resetLogoutTimeout(autoLogout);
  //     };
  //     document.onkeydown = () => {
  //       resetLogoutTimeout(autoLogout);
  //     };
  //   }
  // }, [cookies.EMAIL]);

  const [showHeader, setHeader] = useState(true);

  function toggleShow() {
    setHeader(!showHeader);
  }

  return (
    <>
      <div style={{display: "flex"}}>
        <div style={{ top: 0, position: "fixed", width: "100%", zIndex: "5"}}>
          <Header
            confirmLogout={confirmLogout}
            showHeader={showHeader}
            // toggleShow={toggleShow}
          />
        </div>     
        <div className="content" /*style={{ display: "flex" }}*/>
          {/* <button
            style={{
              // marginBottom: "1rem",
              // marginRight: "1rem",
              border: "none",
              backgroundColor: "white",
              // boxShadow: "0 2px 3px 0px rgba(0, 0, 0, 0.07)",
            }}
            onClick={toggleShow}
          >
            {showHeader ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}

          </button> */}
          <Outlet />
        </div>
      </div>
      {/* <div className="footer">
        <p> Copyright @ 2023 by Cimation (M) Sdn. Bhd. All rights reserved. </p>
      </div> */}

      {/* <AutoLogoutModal
        onHide={autoLogoutModalHide}
        showHide={checkLogoutShow}
        confirmLogout={confirmAutoLogout}
        resetLogoutTimeout={autoLogoutModalHide}
      /> */}
    </>
  );
};

export default Layout;
